import React from "react";
import Home from "./Components/Home";
import Faq from "./Components/Faq";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import MainContent from "./Components/MainContent";
import Tickets from "./Components/Tickets";
import data from "./data.json";
import dataUK from "./data-uk.json";
import dataCA from "./data-ca.json";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/faq">
          <Faq />
        </Route>
        <Route path="/int/uk">
          <Home>
            <MainContent />
            {/* <Tickets showIntl={false} data={dataUK} /> */}
          </Home>
        </Route>
        <Route path="/int/ca">
          <Home>
            <MainContent />
            {/* <Tickets showIntl={false} showCaUs={true} data={dataCA} /> */}
          </Home>
        </Route>
        <Route path="/">
          <Home>
            <MainContent />
            {/* <Tickets showIntl={true} data={data} /> */}
          </Home>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
